<template>
  <v-chip
    class="recipe-label"
    color="secondary darken-1"
    text-color="accent"
    small
  >
    <v-avatar class="secondary darken-2 white--text">
      <v-icon small>{{ icon }}</v-icon>
    </v-avatar>
    <slot>{{ value }}</slot>
  </v-chip>
</template>
<script>
export default {
  name: "RecipeLabel",
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.recipe-label {
  border-width: 0;
}
</style>
